export const PRIVACY_SETTINGS_EVENT = "digifist:privacy-settings";

export function openPrivacySettings() {
  window.dispatchEvent(new Event(PRIVACY_SETTINGS_EVENT));
}

export function privacySettingsLabel(locale: string | undefined) {
  if (locale === "nl-be") return "Cookie-instellingen";
  if (locale === "tr-tr") return "Çerez ayarları";
  return "Cookie settings";
}
